export default __webpack_public_path__ + "static/media/key-graphic.37996a05.png";